"use strict"

import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"

import { isLTPM } from "../../../components/shared_components_registration"
import ObservationSelectorPopper from "../plotting/widgets/ObservationSelectorPopper"

const registration = {
  choose_metrics: (intl) =>
    isLTPM ? intl.formatMessage({ id: "general.dropdown.choose.metric" }) : "Choose Metrics",
}

export const useTagListState = (initialValue) => {
  const [plotOptions, setPlotOptions] = useState([])
  const [tagOptions, setTagOptions] = useState([])
  useEffect(() => {
    const opts = initialValue
      .filter(
        (plot) =>
          !plot.special &&
          (plot?.observations || []).length > 0 &&
          !["Presets", "Comparisons", "DNAseq", "RNAseq"].includes(plot.category),
      )
      .map((plot) => ({ ...plot, disabled: false }))
    setPlotOptions(opts)
    setTagOptions(opts.map((opt) => opt.observations[0]))
  }, [initialValue])

  return [plotOptions, tagOptions]
}

export default function TagOptionsWidget({
  plotList,
  updateTagList,
  intl,
  placement,
  style = {},
  disabled = false,
  siteReactors = [],
}) {
  const [plotOptions, _] = useTagListState(plotList)

  return (
    <ObservationSelectorPopper
      placement={placement}
      options={plotOptions}
      nameFn={(plot) => plot.title}
      onSelect={(sel) => updateTagList([sel])}
      onMultiTagSubmit={(selections) => updateTagList(selections)}
      runFilters={siteReactors}
    >
      <Button
        title={registration.choose_metrics(intl)}
        className={"btn btn-sm"}
        style={style}
        disabled={disabled}
        variant={"outline-primary"}
      >
        <span className={"fa fa-plus-circle"} style={!disabled ? {} : { color: "grey" }} />
      </Button>
    </ObservationSelectorPopper>
  )
}
